import zreportapi from "../../../../services/zreport";

export const fetchCashierPaymentsApi = async (branchId, transactionDate) => {
  const response = await zreportapi.get(
    `DataCashierPayments/branch/${branchId}/transaction-date/${transactionDate}?page=1&size=100`
  );
  return response.data;
};

export const addCashierPaymentApi = async (payment) => {
  const response = await zreportapi.post("DataCashierPayments", payment);
  return response.data;
};

export const updateCashierPaymentApi = async (id, payment) => {
  const response = await zreportapi.put(`DataCashierPayments/${id}`, payment);
  return response.data;
};

export const deleteCashierPaymentApi = async (id) => {
  const response = await zreportapi.delete(`DataCashierPayments/${id}`);
  return response.data;
};
